import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { PathLocationStrategy, LocationStrategy } from "@angular/common";
import { MaterialFileInputModule } from "ngx-material-file-input";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { ToastrModule } from "ngx-toastr";
import { MatInputModule } from "@angular/material/input";
import { MatGridListModule } from '@angular/material/grid-list';
import {
  MatTableModule,
  MatSortModule,
  MatExpansionModule,
  MatDialogModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MAT_DATE_LOCALE,
  DateAdapter,
  MAT_DATE_FORMATS,
  MatDateFormats,
  MatProgressSpinnerModule,
  MatRadioModule,
} from "@angular/material";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatMenuModule } from "@angular/material/menu";
import { MatToolbarModule } from "@angular/material";
import { MatSelectModule } from "@angular/material/select";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule } from "./shared/shared.module";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatCardModule } from "@angular/material/card";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatTabsModule } from "@angular/material/tabs";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { TextFieldModule } from "@angular/cdk/text-field";
import { AddEmployeeDetailsComponent } from "./onboarding/add-employee-details/add-employee-details.component";
import { OnboardingService } from "./shared/service/onboarding.service";
import { ProfileService } from "./shared/service/profile-ms-teams.service";
import { AppConfig } from "./app.config";
import { AddOnboardingDetailsComponent } from "./onboarding/add-onboarding-details/add-onboarding-details.component";
import {
  AuthenticationGuard,
  MsAdalAngular6Module,
} from "microsoft-adal-angular6";
// import { MsalModule } from '@azure/msal-angular';

//import { GoalsComponent } from './all-goals/goals/goals.component';
import { ScrollingModule } from "@angular/cdk/scrolling";
//import { GoalsEditDialogComponent } from './all-goals/goals-edit-dialog/goals-edit-dialog.component';
import { EmployeeListComponent } from "./onboarding/employee-list/employee-list.component";
import { EmployeeProfilesListComponent } from "./employee-profiles-list/employee-profiles-list.component";
import { LocalStorageService } from "./shared/service/local-storage.service";
import { UserService } from "./shared/service/user.service";
import { ConfirmDialogComponent } from "./shared/components/confirm-dialog/confirm-dialog.component";
import { StatusDialogComponent } from "./shared/components/status-dialog/status-dialog.component";
import { OnboardActivationComponent } from "./onboarding/onboard-activation/onboard-activation.component";
import { EmployeeVerificationComponent } from "./onboarding/employee-verification/employee-verification.component";
import { FileUploadService } from "./shared/service/fileUpload.service";
import { FileUploadVerService } from "./shared/service/fileUploadVer.service";
import { dataService } from "./shared/service/dataservice.service";
//import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { SpinnerService } from "./shared/service/spinner-service";
import { CanActivateGuard } from "./can-activate.guard";
import { NotAuthorizedComponent } from "./not-authorized/not-authorized.component";
import { CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { BasicEmpDetailsComponent } from "./onboarding/basic-emp-details/basic-emp-details.component";
import { MultipleFilesDialogComponent } from "./shared/components/multiple-files-dialog/multiple-files-dialog.component";
import { EducationDetailsComponent } from "./onboarding/education-details/education-details.component";
import { ReferenceDetailsComponent } from "./onboarding/reference-details/reference-details.component";
import { PreviousEmploymentComponent } from "./onboarding/previous-employment/previous-employment.component";
import { PassportvisaInformationComponent } from "./onboarding/passportvisa-information/passportvisa-information.component";
import { FinanceDetailsComponent } from "./onboarding/finance-details/finance-details.component";
import { PersonalDetailsComponent } from "./onboarding/personal-details/personal-details.component";

import { HREmployeeListComponent } from "./hr/employee-list/hr-employee-list.component";
import { HrEmployeeDetailsComponent } from "./hr/hr-employee-details/hr-employee-details.component";
import { HrBasicDetailsComponent } from "./hr/hr-basic-details/hr-basic-details.component";
import { HrEmpCommunicationDetailsComponent } from "./hr/hr-emp-communication-details/hr-emp-communication-details.component";
import { HrAwardsComponent } from "./hr/hr-awards/hr-awards.component";
import { NumericDirective } from "./shared/pipes/numeric-decmial.directive";
import { DesignationDialogComponent } from "./shared/components/designation-dialog/designation-dialog.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { EmployeeInsuranceComponent } from "./insurance/employee-insurance/employee-insurance.component";
import { TechgroupDialogComponent } from "./shared/components/techgroup-dialog/techgroup-dialog.component";
import { ExpertiseDialogComponent } from "./shared/components/expertise-dialog/expertise-dialog.component";
import { HrPermissionListComponent } from "./hr/hr-permission-list/hr-permission-list.component";
import { HrAddPermissionComponent } from "./hr/hr-add-permission/hr-add-permission.component";
import { EmployeeWithoutPermissionComponent } from "./hr/employee-without-permission/employee-without-permission.component";
import { DefaultComponent } from "./default/default.component";
import { MenuPanelComponent } from "./menu-panel/menu-panel.component";
import { EmployeeInsuranceListComponent } from "./insurance/Insurance-list/employee-insurance-list";
import { Ng2SearchPipeModule } from "ng2-search-filter";
import { SetInsuranceOptionsComponent } from "./insurance/set-insurance-options/set-insurance-options.component";
import { SumAssuredListPopupComponent } from "./shared/components/sum-assured-list-popup/sum-assured-list-popup.component";
import { MyProfileSummaryComponent } from "./hr/my-profile-summary/my-profile-summary.component";
//import { MatTableExporterModule } from 'mat-table-exporter';
import { AddOffboardingDetailsComponent } from "./offboarding/add-offboarding-details/add-offboarding-details.component";
import { OffboardingEmployeeListComponent } from "./offboarding/offboarding-employee-list/offboarding-employee-list.component";
import { OffboardingFeedbackComponent } from "./offboarding/offboarding-feedback/offboarding-feedback.component";
import { OffboardingSettingsComponent } from "./offboarding/offboarding-settings/offboarding-settings.component";
import { EmployeeService } from "./shared/service/employee.service";
import { DepartmentDialogComponent } from "./shared/components/department-dialog/department-dialog.component";
import { CadreDialogComponent } from "./shared/components/cadre-dialog/cadre-dialog.component";
import { HrHistoryComponent } from "./hr/hr-history/hr-history.component";
import { VisaDialogComponent } from "./shared/components/visa-dialog/visa-dialog.component";
import { ReasonDialogComponent } from "./offboarding/reason-dialog/reason-dialog.component";
import { HrHiringDetailsComponent } from "./hr/hr-hiring-details/hr-hiring-details.component";
import { ProfilesourceDialogComponent } from "./shared/components/profilesource-dialog/profilesource-dialog.component";
import { CustomHttpInterceptor } from "../Intercepetor/custom-interceptor";
import { EditorModule } from "../../thirdpartycontrols/@tinymce/tinymce-angular";
import { DateDirective, ExampleHeader } from "./shared/pipes/date.directive";
import { ShortDateDirective, ShortDateHeader } from "./shared/pipes/shortDate";
import { AutocompletePositionDirective } from "./shared/pipes/autoCompletePosition";
import { EditAvatarComponent } from "./hr/edit-avatar/edit-avatar.component";
import { EditAvatarVerComponent } from "./hr/edit-avatarVer/edit-avatarVer.component";
import { OffboardingQueueComponent } from "./offboarding/offboarding-queue/offboarding-queue.component";
import { HrEmpInitiateExitComponent } from "./hr/hr-emp-initiate-exit/hr-emp-initiate-exit.component";
import { MultiSelectDropdownComponent } from "./multi-select-dropdown/multi-select-dropdown.component";
import { HrMonthClosureComponent } from "./hr/hr-monthclosure/hr-month-closure.component";
import { HRJoinersDetailsComponent } from "./hr/hr-monthclosure/joiners/hr-joiners-details.component";
import { HRAttritionDetailsComponent } from "./hr/hr-monthclosure/attrition/hr-attrition-details.component";
import { HRDeductionDetailsComponent } from "./hr/hr-monthclosure/deduction/hr-deduction.details.component";
import { HRDesignationChangesDetailsComponent } from "./hr/hr-monthclosure/designationchanges/hr-designationchanges-details.component";
import { HROtherEarningsDetailsComponent } from "./hr/hr-monthclosure/otherearnings/hr-otherearnings-details.component";
import { HRLoPDetailsComponent } from "./hr/hr-monthclosure/lop/hr-lop-details.component";
import { HrNominationComponent } from "./awards/hr-nomination/hr-nomination.component";
import { HRAllowancesDetailsComponent } from "./hr/hr-monthclosure/allowances/hr-allowances-details.component";
import { GroupIdConfirmDialogComponent } from "./shared/components/group-id-confirm-dialog/group-id-confirm-dialog.component";
import { ExitInterviewFormComponent } from "./offboarding/exit-interview-form/exit-interview-form.component";
import { ExitEmpFormComponent } from "./offboarding/exit-emp-form/exit-emp-form.component";
import { ExitAddDialogComponent } from "./offboarding/exit-add-dialog/exit-add-dialog.component";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { OverlayModule } from "@angular/cdk/overlay";
import { CompensationDialogComponent } from "./shared/components/compensation-dialog/compensation-dialog.component";
import { SkillSetComponent } from "./hr/skill-set/skill-set.component";
import { ProfileComponent } from "./hr/profile-ms-teams/profile-ms-teams.component";
import { HRHolidaysLsitComponent } from "./hr/hr-holidays-list/hr-holidays-list.component";
import { HRHolidaysDetailsComponent } from "./hr/hr-holidays-details/hr-holidays-details.component";
//import { CdkDropList, CdkDrag} from '@angular/cdk/drag-drop';
import { IdleTimeoutService } from './shared/service/idle-timeout.service'; // Import the Idle Timeout service

export const MY_FORMATS: MatDateFormats = {
  parse: {
    dateInput: "DD-MMM-YYYY",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@NgModule({
  declarations: [
    ExampleHeader,
    NumericDirective,
    DateDirective,
    ShortDateDirective,
    AppComponent,
    AutocompletePositionDirective,
    MenuPanelComponent,
    AddEmployeeDetailsComponent,
    AddOnboardingDetailsComponent,
    NotAuthorizedComponent,
    AddEmployeeDetailsComponent,
    AddOnboardingDetailsComponent,
    EmployeeListComponent,
    EmployeeProfilesListComponent,
    OnboardActivationComponent,
    ConfirmDialogComponent,
    StatusDialogComponent,
    EmployeeVerificationComponent,

    MultipleFilesDialogComponent,
    BasicEmpDetailsComponent,
    EducationDetailsComponent,
    ReferenceDetailsComponent,
    PreviousEmploymentComponent,
    PassportvisaInformationComponent,
    FinanceDetailsComponent,
    PersonalDetailsComponent,

    HREmployeeListComponent,
    HrEmployeeDetailsComponent,
    HrBasicDetailsComponent,
    EditAvatarComponent,
    EditAvatarVerComponent,
    HrEmpCommunicationDetailsComponent,
    HrAwardsComponent,
    HrPermissionListComponent,
    HrAddPermissionComponent,
    DesignationDialogComponent,
    TechgroupDialogComponent,
    ExpertiseDialogComponent,
    EmployeeInsuranceListComponent,
    EmployeeInsuranceComponent,
    // SubmissionComponent
    EmployeeWithoutPermissionComponent,
    DefaultComponent,
    SetInsuranceOptionsComponent,
    AddOffboardingDetailsComponent,
    OffboardingEmployeeListComponent,
    OffboardingFeedbackComponent,
    OffboardingFeedbackComponent,
    OffboardingSettingsComponent,
    OffboardingQueueComponent,
    SumAssuredListPopupComponent,
    MyProfileSummaryComponent,
    DepartmentDialogComponent,
    CadreDialogComponent,
    HrHistoryComponent,
    VisaDialogComponent,
    HrHiringDetailsComponent,
    ProfilesourceDialogComponent,
    HrEmpInitiateExitComponent,
    MultiSelectDropdownComponent,
    HrMonthClosureComponent,
    HRJoinersDetailsComponent,
    HRAttritionDetailsComponent,
    HRDeductionDetailsComponent,
    HRDesignationChangesDetailsComponent,
    HRLoPDetailsComponent,
    HROtherEarningsDetailsComponent,
    HrNominationComponent,
    HRAllowancesDetailsComponent,
    ExitInterviewFormComponent,
    ExitEmpFormComponent,
    GroupIdConfirmDialogComponent,
    ExitAddDialogComponent,
    CompensationDialogComponent,
    SkillSetComponent,
    ProfileComponent,
    HRHolidaysLsitComponent,
    HRHolidaysDetailsComponent,
    ReasonDialogComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatAutocompleteModule,
    SharedModule,
    HttpClientModule,
    FormsModule,
    ScrollingModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatGridListModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatSortModule,
    MatCardModule,
    MatSelectModule,
    MatTabsModule,
    MatPaginatorModule,
    MatBottomSheetModule,
    TextFieldModule,
    MatMenuModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    BrowserModule,
    MatToolbarModule,
    BrowserAnimationsModule,
    MatTooltipModule,
    HttpClientModule,
    EditorModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    //MatTableExporterModule,
    MaterialFileInputModule,
    NgSelectModule,
    Ng2SearchPipeModule,
    DragDropModule,
    OverlayModule,

    MsAdalAngular6Module.forRoot({
      //DEV
      //tenant: 'bdcfaa46-3f69-4dfd-b3f7-c582bdfbb820',
      //clientId: 'ae7f9502-ba12-40a1-bdc2-7a8e6b471b79',
      //redirectUri: 'http://localhost:4200',

      //QA
      //tenant: 'bdcfaa46-3f69-4dfd-b3f7-c582bdfbb820',
      //clientId: 'bb8504b5-ba0f-418a-bc61-e726456975f4',
      //redirectUri: 'https://qa-winemployee.azurewebsites.net/',


      //Production
       tenant: 'bdcfaa46-3f69-4dfd-b3f7-c582bdfbb820',
       clientId: '78c46536-0747-499b-bb3f-929da2cddd1e',
       redirectUri: 'https://winemployee.winwire.com/',

      endpoints: {
        "https://winhrapi.azurewebsites.net/api": "xxx-bae6-4760-b434-xxx",
      },

      //endpoints: {
      //  "https://localhost:44300/Api/": "xxx-bae6-4760-b434-xxx",
      //},
      navigateToLoginRequestUrl: false,
      cacheLocation: "localStorage",
    }),
    ToastrModule.forRoot(),
  ],
  providers: [
    AppConfig,
    EmployeeService,
    OnboardingService,
    ProfileService,
    AuthenticationGuard,
    LocalStorageService,
    UserService,
    FileUploadService,
    SpinnerService,
    dataService,
    IdleTimeoutService,
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: MAT_DATE_LOCALE, useValue: "en-US" },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true,
    },

    CanActivateGuard,
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  entryComponents: [
    OnboardActivationComponent,
    AddEmployeeDetailsComponent,
    DefaultComponent,
    ExampleHeader,
    ConfirmDialogComponent,
    StatusDialogComponent,
    MultipleFilesDialogComponent,
    SumAssuredListPopupComponent,
    DesignationDialogComponent,
    TechgroupDialogComponent,
    ExpertiseDialogComponent,
    DepartmentDialogComponent,
    CadreDialogComponent,
    GroupIdConfirmDialogComponent,
    VisaDialogComponent,
    ProfilesourceDialogComponent,
    ExitAddDialogComponent,
    CompensationDialogComponent,
    ReasonDialogComponent,
  ],
  exports: [MultiSelectDropdownComponent],
})
export class AppModule {}
